export const promptFile = (callback = (_) => {}) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = '.csv'
    input.onchange = e => {
        callback(e.target.files[0]);
    }

    input.click();
};

export const getTextFromFile = (file, callback = (_) => {}) => {
    const reader = new FileReader();
    reader.onload = (event) => {
        callback(event.target.result);
    };
    reader.readAsText(file);
}